/**
 * Сортировка
 */
export default class Sort {
    /**
     * @param {string} field
     * @param {string} order
     */
    constructor(field, order) {
        this.field = field;
        this.order = order;
    }

    /**
     * @returns {string}
     */
    getField() {
        return this.field;
    }

    /**
     * @returns {string}
     */
    getOrder() {
        return this.order;
    }
}
